import { RouterModule, Routes } from '@angular/router';

import { AdminGuardService } from './services/admin-guard.service';

import { LoginGuardService } from './services/login-guard.service';
import { NgModule } from '@angular/core';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'cambiaPassword',
    loadComponent: () => import('./cambia-password/cambia-password.component').then((m) => m.CambiaPasswordComponent),
    pathMatch: 'full',
  },
  {
    path: 'dashboard/home',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/monitoraggio',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/utenti',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/operatori',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/modelli',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/devices',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/commesse',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/commesse/fasi',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/cps',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/gateway',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/ambienti',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/classificazione',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/archiviati',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/profili',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/configurazioni',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    canActivate: [AdminGuardService],
    pathMatch: 'full',
  },
  {
    path: 'dashboard/aziende',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    // canActivate: [AdminGuardService],
    pathMatch: 'full',
  },
  {
    path: 'configuratore',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    //  canActivate: [LoginGuardService],
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then((m) => m.LoginComponent),
    // canActivate: [AdminGuardService],
    pathMatch: 'full',
  },
  {
    path: '404',
    loadComponent: () => import('./dashboard/wrapper-dash/wrapper-dash.component').then((m) => m.WrapperDashComponent),
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
